export const SHIP_TO_COUNTRIES = [
  { code: 'IL', nameEn: 'Israel', nameHe: 'ישראל' },
  { code: 'US', nameEn: 'United States', nameHe: 'ארצות הברית' },
  { code: 'GB', nameEn: 'United Kingdom', nameHe: 'בריטניה' },
  { code: 'DE', nameEn: 'Germany', nameHe: 'גרמניה' },
  { code: 'FR', nameEn: 'France', nameHe: 'צרפת' },
  { code: 'IT', nameEn: 'Italy', nameHe: 'איטליה' },
  { code: 'ES', nameEn: 'Spain', nameHe: 'ספרד' },
  { code: 'PL', nameEn: 'Poland', nameHe: 'פולין' },
  { code: 'AT', nameEn: 'Austria', nameHe: 'אוסטריה' },
  { code: 'AU', nameEn: 'Australia', nameHe: 'אוסטרליה' },
  { code: 'BG', nameEn: 'Bulgaria', nameHe: 'בולגריה' },
  { code: 'RU', nameEn: 'Russia', nameHe: 'רוסיה' },
];

export const SUPPORTED_CURRENCIES = [
  { code: 'NIS', sign: '₪', nameEn: 'Israeli Shekel', nameHe: 'שקל חדש' },
  { code: 'USD', sign: '$', nameEn: 'US Dollar', nameHe: 'דולר אמריקאי' },
  { code: 'EUR', sign: '€', nameEn: 'Euro', nameHe: 'אירו' },
  { code: 'GBP', sign: '£', nameEn: 'British Pound', nameHe: 'לירה שטרלינג' },
];
